import {
  AfterViewInit,
  Component,
  Input,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  IxAlignHorizontal,
  IxFilterFromUrlBuilder,
  IxFilterGroupDynamicComponent,
  IxFilterLookupEvent,
  IxFilterTableConfig,
  IxFilterTableParentDTO,
  IxFormGroupUtil,
  IxKeyValueLookupService,
  IxNgBusyFormService,
  IxNgComponentsModule,
  IxNgConfirmationService,
  IxNgFormatService,
  IxNgHtmlStaticUtils,
  IxParentDTO,
  IxReportColumn,
  IxReportFilterDTO,
  IxServiceBaseUtil,
  IxValidationDialogComponent,
  RowDTO,
} from 'ix-ng-components';
import { Language, LetterCode } from './vpoglednik.enum';
import {
  GroupDTO,
  ROUTER_IDENTIFIER_JEZIK,
  ROUTER_IDENTIFIER_LETO,
  UvozLogDTO,
  VpoglednikFilterDTO,
  VpoglednikPageState,
} from './vpoglednik.model';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  IxFilterTableReportBaseComponent,
  IxFlexGridFilterComponent,
  IxFlexGridReportComponent,
  IxGridStateReport,
  IxNgWijmoModule,
  IxWijmoReportCommon,
} from 'ix-ng-wijmo';
import {
  IxFormBuilder,
  IxNgErrorHandlingService,
  IxNgFormsService,
  IxNgValidationService,
} from 'ix-ng-forms';
import { IxKeycloakHttp, IxNgHttpService } from 'ix-ng-http';
import { IxNgRoutingService } from 'ix-ng-routing';
import { Location } from '@angular/common';
import { fromEvent, map, Subscription } from 'rxjs';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as wjcGridDetail from '@grapecity/wijmo.grid.detail';
import { ObcinaLookupFilterDTO } from '../lib/lookup/obcina-lookup/obcina-lookup.model';
import {
  ObcinaLookupComponent,
  ObcinaLookupService,
  RowsLookupComponent,
  RowsLookupService,
} from 'vpo-shared';
import { RowsLookupDTO, RowsLookupFilterDTO } from '../lib/lookup/rows-lookup/rows-lookup.model';
import { UkrepLookupFilterDTO } from '../lib/lookup/ukrep-lookup/ukrep-lookup.model';
import { UkrepLookupService } from '../lib/lookup/ukrep-lookup/ukrep-lookup.service';
import { IxWijmoFormat, IxWijmoUtils, UndefinedOrNull } from 'ix-ng-static-utils';
import { Aggregate } from '@grapecity/wijmo';
import { FlexgridPaginatorComponent } from '../lib/flexgrid-paginator/flexgrid-paginator.component';
import { Tooltip } from 'primeng/tooltip';
import { Button } from 'primeng/button';
import { VpoFilterLookupComponent } from '../lib/filter/lookup/vpo-filter-lookup.component';
import { VpoFilterNumberComponent } from '../lib/filter/number/vpo-filter-number.component';
import { VpoFilterStringComponent } from '../lib/filter/string/vpo-filter-string.component';
import { UkrepLookupComponent } from '../lib/lookup/ukrep-lookup/ukrep-lookup.component';
import { MultiSelectStyle } from 'primeng/multiselect';
import { AutoCompleteStyle } from 'primeng/autocomplete';

@Component({
  selector: 'lib-vpoglednik',
  templateUrl: './vpoglednik.component.html',
  styleUrl: './vpoglednik.component.scss',
  imports: [
    IxNgWijmoModule,
    FlexgridPaginatorComponent,
    IxValidationDialogComponent,
    Tooltip,
    Button,
    RowsLookupComponent,
    VpoFilterLookupComponent,
    VpoFilterNumberComponent,
    IxFilterGroupDynamicComponent,
    VpoFilterStringComponent,
    IxNgComponentsModule,
    ObcinaLookupComponent,
    UkrepLookupComponent,
  ],
  providers: [
    IxKeyValueLookupService,
    ObcinaLookupService,
    RowsLookupService,
    UkrepLookupService,
    MultiSelectStyle,
    AutoCompleteStyle,
  ],
})
export class VpoglednikComponent
  extends IxFilterTableReportBaseComponent<RowDTO, VpoglednikFilterDTO>
  implements OnInit, AfterViewInit, OnDestroy
{
  private router: Router;

  protected readonly Language = Language;
  protected jezik: Language = Language.SI;
  protected leto: number;
  private prviRead = true;
  public grupeZaprte = true;
  private tagSeznamDefault = ['a', 'b', 'c', 'e', 'k', 'n', 'o'];
  private tagSeznamExpended = ['a', 'b', 'c', 'e', 'i', 'j', 'k', 'l', 'm', 'n', 'o'];
  public tabelaRazsirjena = false;
  private windowWidth = window.innerWidth;
  private columnFormatMap: Record<string, string> = {};
  public limitVrstic = 10000;

  public ixNgFormatService = inject(IxNgFormatService);
  public ixNgValidationService = inject(IxNgValidationService);
  private obcinaLookupService = inject(ObcinaLookupService);
  private rowsLookupService = inject(RowsLookupService);
  private ukrepLookupService = inject(UkrepLookupService);

  @Input()
  public isAdmin = false;
  private uvozLog: UvozLogDTO | null = null;

  private groupStateSnapshot: GroupDTO[] = [];

  @ViewChild('ixFlexGridFilter')
  public ixFlexGridFilter?: IxFlexGridFilterComponent;

  @ViewChild('reportGrid')
  private reportGrid?: IxFlexGridReportComponent<VpoglednikFilterDTO>;

  override gridState: IxGridStateReport<VpoglednikFilterDTO>;
  private detailGridProvider: wjcGridDetail.FlexGridDetailProvider | undefined;

  override ixServiceUtil: IxServiceBaseUtil;
  override ixUtilFilter: IxFormGroupUtil<
    IxFilterTableParentDTO<VpoglednikFilterDTO>,
    VpoglednikFilterDTO
  >;
  protected readonly defaultFilterTableConfig = new IxFilterTableConfig();

  constructor() {
    const ixFormBuilder = inject(IxFormBuilder);
    const ixNgFormsService = inject(IxNgFormsService);
    const ixKeycloakHttp = inject(IxKeycloakHttp);
    const ixNgErrorHandlingService = inject(IxNgErrorHandlingService);
    const ixNgHttpService = inject(IxNgHttpService);
    const ixNgBusyFormService = inject(IxNgBusyFormService);
    const ixNgRoutingService = inject(IxNgRoutingService);
    const ixNgConfirmationService = inject(IxNgConfirmationService);
    const ixKeyValueLookupService = inject(IxKeyValueLookupService);
    const location = inject(Location);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      ixFormBuilder,
      ixNgFormsService,
      ixKeycloakHttp,
      ixNgErrorHandlingService,
      ixNgHttpService,
      ixNgBusyFormService,
      ixNgRoutingService,
      ixKeyValueLookupService,
      location,
      VpoglednikPageState,
      VpoglednikFilterDTO,
      route,
    );

    this.router = router;

    const letoUrl =
      this.ixNgRoutingService.getRouteParamsFromActivatedRoute(route)[ROUTER_IDENTIFIER_LETO];
    const regex = /^-1$|^(20\d{2}|2100)$/;

    if (!regex.test(letoUrl)) {
      this.router.navigateByUrl('404');
    }

    this.leto = parseInt(letoUrl, 10);

    let jezikUrl =
      this.ixNgRoutingService.getRouteParamsFromActivatedRoute(route)[ROUTER_IDENTIFIER_JEZIK];
    if (!Object.values(Language).includes(jezikUrl)) {
      jezikUrl = Language.SI;
    }
    this.jezik = jezikUrl;

    this.ixServiceUtil = new IxServiceBaseUtil(
      ixKeycloakHttp,
      ixNgRoutingService,
      ixNgErrorHandlingService,
      ixNgHttpService,
      ixNgBusyFormService,
    );

    this.ixUtilFilter = new IxFormGroupUtil(
      ixFormBuilder,
      ixNgFormsService,
      ixNgErrorHandlingService,
      IxFilterTableParentDTO,
      VpoglednikFilterDTO,
    );

    this.gridState = new IxGridStateReport<VpoglednikFilterDTO>(
      ixFormBuilder,
      ixNgFormsService,
      this.ixNgErrorHandlingService,
      ixNgConfirmationService,
      this.ixPageState,
      this.podatki,
      this.ixUtilFilter,
      () => this.changeUrl(),
      router,
    );

    this.gridState.columnVisibleFilter = true;
    this.createFilterUrl = 'create-vpoglednik-filter';
    this.readSeznamUrl = 'read-vpoglednik';
    this.imePorocila =
      this.jezik === Language.EN ? 'Recipients of funds - report' : 'Izpis prejemnikov sredstev';
    this.kratkoImePorocila =
      this.jezik === Language.EN ? 'Recipients of funds - report' : 'Izpis prejemnikov sredstev'; // pod 31 char
    this.avtorPorocila = 'ARSKTRP';

    this.setLanguage(this.jezik, false);
  }

  ngOnInit() {
    // URL ni imel leta
    if (this.leto === -1) {
      this.ixServiceUtil.safeCall(
        () => this.ixServiceUtil.get<number>('get-proracunsko-leto'),
        (leto) => {
          if (leto) {
            this.router.navigate(['/vpoglednik', '' + leto, this.jezik]).then(() => {
              location.reload();
            });
          } else {
            this.router.navigateByUrl('404');
          }
        },
        undefined,
        () => this.router.navigateByUrl('404'),
      );
      // URL ima leto, in ga preverimo
    } else {
      this.ixServiceUtil.safeCall(
        () => this.ixServiceUtil.get<boolean>(`preveri-leto`),
        (letoOk) => {
          if (letoOk) {
            this.getReportDefinition();
          } else {
            this.router.navigateByUrl('404');
          }
        },
        undefined,
        () => this.router.navigateByUrl('404'),
      );
    }
  }

  getReportDefinition() {
    // prvo preberemo vse default stolpce, ki jih imamo v porocilu (izbrane stolpce, grupirane stolpce in stolpec, pa katerem se sortira)
    this.ixServiceUtil.safeCall(
      () => this.ixServiceUtil.get<IxParentDTO<IxReportFilterDTO>>('get-report-definition'),
      (model) => {
        if (model && model.row) {
          this.gridState.setReportDefinition(model.row);
          this.reportDefinitionLoaded = true;
          this.restoreFromUrl(this.ixPageState);
        }
      },
    );
  }

  override readFilter(preventRead = false) {
    const filter = this.ixUtilFilter.getFormRowValue() || new VpoglednikFilterDTO();
    this.prviRead = true;
    // pridobimo izbrane opcijske filtre (lookup Dodatni kriteriji)
    this.selectedFilterItems = filter.selectedFilterItems = this.ixFilterGroup
      ? this.ixFilterGroup.selectedFilterItems
      : [];

    if (filter && !filter.imePogleda) filter.imePogleda = null;
    this.ixUtilFilter.setFormRowValue(filter);

    if (!preventRead) {
      this.ixUtilFilter.saveItem(
        false,
        (model, ignoreWarnings) => {
          return this.ixServiceUtil.post<Record<string, object>[]>(this.readSeznamUrl, model, {
            ignoreWarnings,
          });
        },
        (resultSet) => {
          if (resultSet) {
            this.customSortiranjePoGrupah('', resultSet as never[]);
            this.gridState.setResultSet(resultSet);
            // timeout je nujen, ker se mora tole zgoditi po setResultSet, ki ima setTimeout
            setTimeout(() => {
              this.theGrid?.columns.forEach(
                (col) =>
                  (col.width = ['NAZIV', 'NAZIV_MD_DS', 'UKREP_SI', 'UKREP_EN'].includes(
                    col.binding as string,
                  )
                    ? '2*'
                    : '*'),
              );
              if (this.prviRead) {
                if (IxNgHtmlStaticUtils.mobile) {
                  this.recreateFlexGridSelectedColumns();
                }
                this.theGrid?.rows.forEach((row) => {
                  if (row instanceof wjcGrid.GroupRow) {
                    row.isCollapsed = true;
                  }
                });
                this.prviRead = false;
              }

              // nastavimo custom message na grid
              if (this.reportGrid)
                this.reportGrid.gridMessage = this.getGridMessage(resultSet.length);
            }, 1);
            this.savePageState();
            this.changeUrl();
            this.setHeader();
            if (this.isAdmin) {
              this.readUvozLog();
            }
            this.grupeZaprte = true;
          }
        },
      );
    } else {
      this.ixUtilFilter.ixFormGroup.markAsDirty();
    }
  }

  private readUvozLog() {
    this.ixServiceUtil.safeCall(
      () => this.ixServiceUtil.get<UvozLogDTO>('get-uvoz-log'),
      (model) => {
        if (model && model.leto) {
          this.uvozLog = model;
          this.setHeader();
        }
      },
    );
  }

  ngAfterViewInit() {
    if (!this.subscription) {
      setTimeout(() => {
        this.subscription = new Subscription();
        this.theGrid = this.gridState.setFlexGridTable(this.subscription, {
          showSummary: false,
          fullGroupName: true,
          showFreezeBar: false,
          showSteviloZapisov: true,
          ixFlexGridFilter: this.ixFlexGridFilter,
          bottomPadding: IxNgHtmlStaticUtils.mobile ? 50 : 100,
        });
        // formatItem iz ogrodja ne dela v primeru, da imamo detail row, zato ga odstranimo
        this.theGrid.formatItem.removeAllHandlers();
        this.theGrid.selectionMode = wjcGrid.SelectionMode.None;
        this.theGrid.rows.defaultSize = 30;
        this.subscription.add(
          this.theGrid?.formatItem.addHandler(
            (flexGrid: wjcGrid.FlexGrid, event: wjcGrid.FormatItemEventArgs) =>
              this.formatItem(flexGrid, event),
          ),
        );
        this.subscription.add(
          this.theGrid?.sortingColumn.addHandler(
            (flexGrid: wjcGrid.FlexGrid, event: wjcGrid.CellRangeEventArgs) => {
              // ujamemo stanje zaprtih / odprtih grup, ker se po sortiranju vse default odprejo
              this.makeGroupSnapshot();

              const view = this.gridState.podatki;
              let oldPage = view.pageSize;
              let oldIndex = view.pageIndex;
              this.gridState?.theGrid?.beginUpdate();
              if (this.gridState.resultSetCount > this.limitVrstic) {
                oldPage = view.pageSize;
                oldIndex = view.pageIndex;
                view.pageSize = 0;
              }

              const binding = event.panel.columns[event.col].binding as string;
              this.customSortiranjePoGrupah(binding, flexGrid.collectionView.items as never[]);

              if (this.gridState.resultSetCount > this.limitVrstic) {
                view.pageSize = oldPage;
                view.moveToPage(oldIndex);
              }
              this.gridState?.theGrid?.endUpdate();

              flexGrid.collectionView.refresh();
            },
          ),
        );
        this.subscription.add(
          this.theGrid?.sortedColumn.addHandler(() => {
            if (this.gridState.resultSetCount > this.limitVrstic) {
              this.collapseGroups();
            } else {
              this.restoreGroupSnapshot();
            }
          }),
        );
        // ko postane okno premajhno, avtomatsko gremo na dynamic columns
        this.subscription.add(
          fromEvent(window, 'resize').subscribe(() => {
            if (
              this.windowWidth >= IxNgHtmlStaticUtils.breakPointWidth - 1 &&
              window.innerWidth < IxNgHtmlStaticUtils.breakPointWidth - 1
            ) {
              this.recreateFlexGridSelectedColumns();
            }
            if (
              window.innerWidth >= IxNgHtmlStaticUtils.breakPointWidth - 1 &&
              this.windowWidth < IxNgHtmlStaticUtils.breakPointWidth - 1
            ) {
              this.recreateFlexGridSelectedColumns();
            }
            this.windowWidth = window.innerWidth;
          }),
        );

        // pripnemo detail provider na grid - podatke napolnimo v createDetailCell
        this.detailGridProvider = new wjcGridDetail.FlexGridDetailProvider(this.theGrid, {
          isAnimated: false,
          maxHeight: 600,
          detailVisibilityMode: wjcGridDetail.DetailVisibilityMode.Code,
        });

        this.detailGridProvider.createDetailCell = (row) => {
          const div = document.createElement('div');
          const poglavje = row.dataItem['UKREP_' + this.jezik]
            ? row.dataItem['UKREP_POGLAVJE_' + this.jezik]
            : '/';
          const ukrep = row.dataItem['UKREP_' + this.jezik]
            ? row.dataItem['UKREP_' + this.jezik]
            : '/';
          const opis = row.dataItem['UKREP_' + this.jezik]
            ? row.dataItem['UKREP_OPIS_' + this.jezik]
            : '/';
          div.innerHTML =
            `<div class="detail-container"><p class="detail-besedilo"><b>${poglavje}</b></p>` +
            `<p class="detail-besedilo" style="font-style: italic"><b>${ukrep}</b></p>` +
            `<p class="detail-besedilo">${opis}</p></div>`;
          return div;
        };
      }, 0);
    }
  }

  /**
   * Na Vpogledniku so grupirane vrstice malo posebne, zato je zanje narejen custom sort. SORT poteka po vrednosti v grupi, ki prestavlja sortiran stolpec in ID PREJEMNIKA.
   * Izdelani so 3 različni tipi sortiranja, ker je potrebno upoštevati različne tipe podatkov. Za številke se ID PREJEMNIKA doda v decimalke, za besedilo pa se najprej pretvori
   * prve tri črke v številke in se ID PREJEMNIKA doda na konec (za krajša besedila oziroma večinoma prazne stolpce) ali pa se uporabi vrstni red iz baze.
   * Za desc sortiranje se uporabi negativna števila.
   */
  customSortiranjePoGrupah(binding: string, seznam: never[]) {
    const sortedColDesc = this.theGrid?.collectionView?.sortDescriptions
      ? this.theGrid.collectionView.sortDescriptions[0]
      : null;
    const sortedCol = sortedColDesc ? sortedColDesc.property : null;
    let ascending: string;

    if (!binding || binding === '') {
      if (!sortedCol) {
        return;
      }
      binding = sortedCol;
      ascending = sortedColDesc?.ascending ? '' : '-';
    } else {
      ascending = binding !== sortedCol || !sortedColDesc?.ascending ? '' : '-';
    }

    if (
      [
        'ZNESEK_SKUPAJ',
        'EKJS_SKUPAJ',
        'EKSRP_SKUPAJ',
        'EKJS_EU',
        'EKJS_SLO',
        'EKSRP_EU',
        'EKSRP_SLO',
      ].includes(binding)
    ) {
      // najprej nastavimo grupe, da ne loopamo čez vse podatke še enkrat za vsako vrstico
      const groups = new Map<string, never[]>();
      if (this.theGrid?.collectionView?.items !== seznam || !this.theGrid?.collectionView.groups) {
        seznam.forEach((item) => {
          const key = item['PREJEMNIK_ID'];
          if (!groups.has(key)) {
            groups.set(key, []);
          }
          groups.get(key)!.push(item);
        });
      } else {
        this.theGrid.collectionView.groups.forEach((group) => {
          const key = group.items[0]['PREJEMNIK_ID'];
          groups.set(key, group.items);
        });
      }
      groups.forEach((items, id) => this.urediNumberGrupo(items, id, binding, ascending));
    } else if (binding === 'NAZIV') {
      seznam.forEach(
        (item) =>
          ((item['GROUP_ID'] as number) = +(
            ascending +
            item['NAZIV_ORDER'] +
            item['PREJEMNIK_ID']
          )),
      );
    } else if (binding === 'NAZIV_MD_DS' || binding === 'OBCINA') {
      seznam.forEach(
        (item) =>
          ((item['GROUP_ID'] as number) = +(
            this.stringToNumber(item[binding], binding, ascending) + item['PREJEMNIK_ID']
          )),
      );
    }
  }

  urediNumberGrupo(items: never[], id: string, binding: string, ascending: string) {
    const numberValue =
      Math.round(items.reduce((sum, itm) => sum + (itm[binding] || 0), 0) * 100) / 100;
    let stringValue = numberValue.toString();
    if (!stringValue.includes('.')) {
      stringValue = stringValue + '.00';
    }

    if (ascending === '-') {
      stringValue = stringValue.startsWith('-')
        ? stringValue.replace('-', '')
        : ascending + stringValue;
    }

    stringValue = stringValue + id;
    items.forEach((item) => ((item['GROUP_ID'] as number) = +stringValue));
  }

  stringToNumber(str: string, binding: string, ascending: string): string {
    let num = '';
    if (str) {
      const length = str.length < 3 ? str.length : 3;
      for (let i = 0; i < 3; i++) {
        if (i >= length) {
          num = num + '00';
          continue;
        }
        if (/^[0-9]$/.test(str[i])) {
          num = num + '0' + str[i];
          continue;
        }
        const letterCode = LetterCode[str[i].toUpperCase()];
        num = num + (letterCode ? letterCode : '41');
      }
    } else {
      num = '999999';
    }
    num = ascending + num;
    return num;
  }

  override ngOnDestroy() {
    this.gridState.dispose();
    this.theGrid?.dispose();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  recalculateFlexGrid(toggleDodatno: boolean) {
    if (toggleDodatno && this.ixFilterGroup) {
      this.ixFilterGroup.toggleDodatno();
    }
    if (this.gridState) {
      this.gridState.resizeFlexGrid();
    }
  }

  override clearFilter() {
    if (this.ixFilterGroup) {
      const filter = this.ixFilterGroup.clearNotRequiredFilterItems() as
        | VpoglednikFilterDTO
        | null
        | undefined;
      const defaultRows = new RowsLookupDTO();
      defaultRows.id = 100;
      defaultRows.numberOfRows = '100';
      defaultRows.numberOfRowsAng = '100';
      if (filter) filter.rowsLookupSeznam = [defaultRows];
      if (filter && !filter.imePogleda) filter.imePogleda = null;
      this.ixUtilFilter.setFormRowValue(filter);
    }
  }

  override exportToExcel() {
    if (this.gridState.resultSetCount > this.limitVrstic) {
      this.ixServiceUtil.safeCall(() =>
        this.ixServiceUtil.download('downloadExcel', this.ixUtilFilter.getFormRowValue()).pipe(
          map((x) => {
            return x;
          }),
        ),
      );
    } else {
      const callback = () => {
        this.expendTable(true);
        this.gridState?.theGrid?.endUpdate();
      };

      this.preExcelExport();
      this.theGrid?.columns.forEach((col) => {
        if (
          col.binding === 'NAZIV' ||
          col.binding === 'NAZIV_MD_DS' ||
          col.binding === 'UKREP_SI' ||
          col.binding === 'UKREP_EN'
        ) {
          col.width = 300;
        } else {
          col.width = 150;
        }
      });
      this.gridState?.exportToExcel(
        true,
        this.ixUtilFilter?.getFormRowValue(),
        this.kratkoImePorocila,
        this.imePorocila,
        this.formatItemExcel.bind(this),
        undefined,
        this.avtorPorocila,
        callback,
        callback,
        undefined,
        true,
      );
    }
  }

  protected filterFromUrlBuilderPrepareForLookup(
    ixFilterFromUrlBuilder: IxFilterFromUrlBuilder,
    filter: string,
    params: Params,
  ) {
    switch (filter) {
      case 'obcinaLookupSeznam':
        ixFilterFromUrlBuilder.fromLookup(
          filter,
          () => this.obcinaLookupService.findByIdSeznam(params[filter]),
          false,
        );
        break;
      case 'ukrepLookupSeznam':
        ixFilterFromUrlBuilder.fromLookup(
          filter,
          () => this.ukrepLookupService.findByIdSeznam(params[filter]),
          false,
        );
        break;
      case 'rowsLookupSeznam':
        ixFilterFromUrlBuilder.fromLookup(
          filter,
          () => this.rowsLookupService.findByIdSeznam(params[filter]),
          false,
        );
        break;
      default:
        break;
    }
  }

  setLanguage(language: Language, reload: boolean): void {
    if (language === this.jezik) {
      reload = false;
    }
    this.jezik = language;

    // posodobijo se vsi parametri, ker niso dinamični
    this.ixServiceUtil.serviceUrl = `/vpoglednik/${this.leto}/${this.jezik}`;
    this.changeUrlTo = ['vpoglednik', this.leto + '', this.jezik];
    this.serviceUrl = `/vpoglednik/${this.leto}/${this.jezik}`;

    if (reload) {
      this.router.navigate(['/vpoglednik', '' + this.leto, this.jezik]).then(() => {
        location.reload();
      });
    }
  }

  collapseGroups() {
    this.theGrid?.collapseGroupsToLevel(0);
    this.grupeZaprte = true;
  }

  expendGroups() {
    this.theGrid?.collapseGroupsToLevel(2);
    this.grupeZaprte = false;
  }

  formatItem(grid: wjcGrid.FlexGrid, format: wjcGrid.FormatItemEventArgs) {
    if (!format.panel.cellType) {
      return;
    }

    const row: wjcGrid.Row = grid.rows[format.row];

    if (
      !row ||
      (format.panel.cellType.valueOf() !== 1 && format.panel.cellType.valueOf() !== 3) ||
      row instanceof wjcGridDetail.DetailRow
    ) {
      return;
    }
    const col: wjcGrid.Column = grid.columns[format.col];
    if (!col) {
      return;
    }

    if (row instanceof wjcGrid.GroupRow) {
      if (
        format.panel.cellType.valueOf() === 3 &&
        !format.cell.classList.contains('group-button')
      ) {
        format.cell.classList.add('group-button');
        format.cell.innerHTML = '<span class="far fa-chevron-right"></span>';
        format.cell.onclick = this.groupClicked.bind(this, format.cell, row);
        if (row.isCollapsed) {
          format.cell.classList.add('button-closed');
        } else {
          format.cell.classList.add('button-opened');
        }
        return;
      }

      /**
       * Na Vpogledniku so grupirane vrstice malo posebne. Podatki so grupirani po ID-ju uporabnika (isti posameznik ima lahko več ID-jev).
       * Za isti ID bodo zmeraj enaki Naziv, Naziv DS in Občina. Namesto ID-ja tako prikazujemo te 3 stolpce v eni grupni vrstici.
       */
      if (
        col.binding &&
        ['NAZIV', 'NAZIV_MD_DS', 'OBCINA', 'UKREP_SI', 'UKREP_EN'].includes(col.binding)
      ) {
        const data = row.dataItem.items[0];

        const placilaSkupaj = this.jezik === Language.EN ? 'PAYMENTS TOTAL' : 'PLAČILA SKUPAJ';

        format.cell.innerHTML = col.binding.includes('UKREP')
          ? placilaSkupaj
          : this.valueOrEmpty(data[col.binding]);

        format.cell.style.padding = '4px 6px 0px 6px';
      } else {
        // Ničel ne prikazujemo (če so vse vrednosti NULL)
        if (Math.round(row.dataItem?.getAggregate('Sum', col.binding) * 100) / 100 === 0) {
          if (
            row.dataItem?.items?.filter((item: never) => item[col.binding as string] != null)
              .length === 0
          )
            format.cell.innerHTML = '';
        }
      }

      return;
    }

    format.cell.style.paddingLeft = '';
    format.cell.onclick = null;

    // Ničel ne prikazujemo
    if (
      ['EKJS_SKUPAJ', 'EKSRP_SKUPAJ', 'EKJS_EU', 'EKJS_SLO', 'EKSRP_EU', 'EKSRP_SLO'].includes(
        col.binding as string,
      )
    ) {
      const data = row.dataItem[col.binding as string];
      if (data === 0) {
        format.cell.innerHTML = '';
      }
    }

    // Skupni znesek prikazujemo samo v grupiranih vrsticah
    if (col.binding === 'ZNESEK_SKUPAJ') {
      format.cell.innerHTML = '';
    }

    if (col.binding?.includes('UKREP')) {
      format.cell.onclick = this.showDetail.bind(this, format.row, row);
      format.cell.classList.add('ukrep-column');
    }
  }

  showDetail(row: number, rowReference: wjcGrid.Row) {
    if (!this.detailGridProvider) {
      return;
    }
    if (this.detailGridProvider.isDetailVisible(row)) {
      this.detailGridProvider?.hideDetail(row);
    } else if (rowReference.isVisible) {
      this.detailGridProvider?.showDetail(row);
    }
  }

  formatItemExcel(grid: wjcGrid.FlexGrid, format: wjcGridXlsx.XlsxFormatItemEventArgs) {
    if (!format.panel.cellType || !format.xlsxCell) {
      return;
    }

    const row: wjcGrid.Row = grid.rows[format.row];
    if (!row || format.panel.cellType.valueOf() !== 1) {
      return;
    }

    const col: wjcGrid.Column = grid.columns[format.col];
    if (!col) {
      return;
    }

    if (row instanceof wjcGrid.GroupRow) {
      if (format.xlsxCell.style && format.xlsxCell.style.font) {
        format.xlsxCell.style.font.bold = true;
      } else {
        format.xlsxCell.style = { font: { bold: true } };
      }

      if (
        col.binding &&
        ['NAZIV', 'NAZIV_MD_DS', 'OBCINA', 'UKREP_SI', 'UKREP_EN'].includes(col.binding)
      ) {
        const data = row.dataItem.items[0];

        const placilaSkupaj = this.jezik === Language.EN ? 'PAYMENTS TOTAL' : 'PLAČILA SKUPAJ';

        format.xlsxCell.value = col.binding.includes('UKREP')
          ? placilaSkupaj
          : this.valueOrEmpty(data[col.binding]);
      } else if (
        [
          'EKJS_SKUPAJ',
          'EKSRP_SKUPAJ',
          'EKJS_EU',
          'EKJS_SLO',
          'EKSRP_EU',
          'EKSRP_SLO',
          'ZNESEK_SKUPAJ',
        ].includes(col.binding as string)
      ) {
        // Ničel ne prikazujemo (če so vse vrednosti NULL)
        if (
          Math.round(row.dataItem?.getAggregate('Sum', col.binding) * 100) / 100 === 0 &&
          row.dataItem?.items?.filter((item: never) => item[col.binding as string] != null)
            .length === 0
        ) {
          format.xlsxCell.value = '';
        } else {
          format.xlsxCell.isNumber = true;
          format.xlsxCell.value = row.dataItem.getAggregate('Sum', col.binding) as number;
          if (format.xlsxCell.style) format.xlsxCell.style.format = '#,##0.00';
        }
      }

      return;
    }

    // Ničel ne prikazujemo
    if (
      ['EKJS_SKUPAJ', 'EKSRP_SKUPAJ', 'EKJS_EU', 'EKJS_SLO', 'EKSRP_EU', 'EKSRP_SLO'].includes(
        col.binding as string,
      )
    ) {
      const data = row.dataItem[col.binding as string];
      if (data === 0) {
        format.xlsxCell.value = null;
      } else {
        format.xlsxCell.value = data as number;
        format.xlsxCell.isNumber = true;
        if (format.xlsxCell.style) format.xlsxCell.style.format = '#,##0.00';
      }
    }

    // Skupni znesek prikazujemo samo v grupiranih vrsticah
    if (col.binding === 'ZNESEK_SKUPAJ') {
      format.xlsxCell.value = null;
    }

    // Pri datumih spremenimo format in vrednost, da se lahko v excelu uporablja Date filter
    const colFormat: UndefinedOrNull | IxWijmoFormat =
      this.gridState.reportDefinition?.reportTable?.columnSeznam?.find(
        (x) => x.columnAlias === col.binding,
      )?.format;
    if (colFormat && colFormat === IxWijmoFormat.Date && row.dataItem[col.binding as string]) {
      if (format.xlsxCell.style) {
        format.xlsxCell.style.format = 'dd.MM.yyyy';
        format.xlsxCell.value = row.dataItem[col.binding as string];
        // če damo isDate na true za celice, kjer je null, napolni te celice s 01.01.1970
        format.xlsxCell.isDate = true;
      }
    }
  }

  valueOrEmpty(value: string | undefined): string {
    return value ? value : '';
  }

  onObcinaLookupSeznamChange($event: IxFilterLookupEvent) {
    const filter = new ObcinaLookupFilterDTO();
    filter.prikaziAktivne = true;
    this.obcinaLookupService.filterLookupMethod(undefined, $event, filter);
  }

  onRowsLookupSeznamChange($event: IxFilterLookupEvent) {
    const filter = new RowsLookupFilterDTO();
    filter.prikaziAktivne = true;
    this.rowsLookupService.filterLookupMethod(undefined, $event, filter);
  }

  onUkrepLookupSeznamChange(event: IxFilterLookupEvent) {
    const filter = new UkrepLookupFilterDTO();
    filter.prikaziAktivne = true;
    this.ukrepLookupService.filterLookupMethod(undefined, event, filter);
  }

  private groupClicked(cell: HTMLElement, row: wjcGrid.GroupRow) {
    if (cell.classList.contains('button-closed')) {
      cell.classList.remove('button-closed');
      cell.classList.add('button-opened');
      row.isCollapsed = false;
      this.grupeZaprte = false;
    } else {
      cell.classList.remove('button-opened');
      cell.classList.add('button-closed');
      row.isCollapsed = true;
      if (
        this.theGrid?.rows.filter((r) => r instanceof wjcGrid.GroupRow && !r.isCollapsed).length ===
        0
      ) {
        this.grupeZaprte = true;
      }
    }
  }

  // dodamo stolpce, ki so samo v Excel izvozu
  preExcelExport() {
    // pripravimo grid, da počaka s prikazom, dokler ni vse urejeno
    if (!this.theGrid) {
      return;
    }
    const theGrid: wjcGrid.FlexGrid = this.theGrid;

    theGrid.columns.clear();

    if (this.gridState.reportDefinition?.reportTable?.columnSeznam) {
      this.gridState.reportDefinition?.reportTable?.columnSeznam.forEach(
        (ixReportColumn: IxReportColumn) => {
          const isExcelColumn = this.tabelaRazsirjena
            ? !this.tagSeznamExpended.includes(ixReportColumn.tag as never)
            : !this.tagSeznamDefault.includes(ixReportColumn.tag as never);
          const col: wjcGrid.Column = this.createNewColumn(ixReportColumn, isExcelColumn);
          theGrid.columns.push(col);
        },
      );
    }

    this.setHeader();
  }

  expendTable(onExcel = false) {
    if (!onExcel) {
      this.tabelaRazsirjena = !this.tabelaRazsirjena;
    }

    // pripravimo grid, da počaka s prikazom, dokler ni vse urejeno
    this.theGrid?.deferUpdate(() => {
      // ponovno zgradimo stolpce
      this.recreateFlexGridSelectedColumns();

      // pri razširjeni tabeli ne tlačimo stolpcev
      if (this.tabelaRazsirjena) {
        // naredimo snapshot stanja zaprtih grup
        this.makeGroupSnapshot();

        // razpremo grupe, da bo avtosize upošteval vsebino vrstic
        this.theGrid?.rows.forEach((row) => {
          if (row instanceof wjcGrid.GroupRow) {
            row.isCollapsed = false;
          }
        });

        // naredimo autosize
        this.theGrid?.autoSizeColumns();
        // nekateri stolpci se preveč razširijo, uporabniki jih še zmeraj lahko ročno razširijo
        this.theGrid?.columns.forEach((col) => {
          if (col.width > 300) {
            col.width = 300;
          }
        });

        // zapremo grupe nazaj glede na zadnji snapshot
        this.restoreGroupSnapshot();
      }
    });
  }

  private recreateFlexGridSelectedColumns() {
    if (!this.theGrid) {
      return;
    }
    const theGrid: wjcGrid.FlexGrid = this.theGrid;

    // funkcija za castanje api formata v UI wijmo format ni odprta, zato jih moramo shranjevati
    this.columnFormatMap = {};
    theGrid.columns.forEach((col) => {
      if (col.format) this.columnFormatMap[col.binding as string] = col.format;
    });
    theGrid.columns.clear();

    if (this.gridState.reportDefinition?.reportTable?.columnSeznam) {
      this.gridState.reportDefinition?.reportTable?.columnSeznam
        .filter((col) =>
          this.tabelaRazsirjena
            ? this.tagSeznamExpended.includes(col.tag as string)
            : this.tagSeznamDefault.includes(col.tag as string),
        )
        .forEach((ixReportColumn: IxReportColumn) => {
          const col: wjcGrid.Column = this.createNewColumn(ixReportColumn);
          theGrid.columns.push(col);
        });
    }

    this.setHeader();
  }

  private createNewColumn(ixReportColumn: IxReportColumn, excelColumn = false): wjcGrid.Column {
    const column: wjcGrid.Column = new wjcGrid.Column();
    column.header = ixReportColumn.columnDescription || '';
    column.binding = ixReportColumn.columnAlias || '';
    column.maxWidth = 1000;
    column.width = this.tabelaRazsirjena || IxNgHtmlStaticUtils.mobile ? 100 : '*';
    column.allowMerging = false;
    column.aggregate =
      IxWijmoReportCommon.convertIxAggregateToWijmoAggregate(ixReportColumn.aggregate) ||
      Aggregate.None;
    column.format =
      this.columnFormatMap[column.binding as string] ||
      (ixReportColumn.format === IxWijmoFormat.Float2 ? 'n2' : '');
    column.dataType =
      IxWijmoReportCommon.convertIxDataTypeToWijmoDataType(
        IxWijmoUtils.columnDataType(ixReportColumn.format),
      ) || null;
    column.minWidth = 25;
    column.align =
      ixReportColumn.alignHor === IxAlignHorizontal.Right ||
      ixReportColumn.format === IxWijmoFormat.Float2
        ? 'right'
        : 'left';
    if (excelColumn) {
      column.width = 0;
      column.minWidth = 0;
    }
    return column;
  }

  private makeGroupSnapshot() {
    this.groupStateSnapshot = [];
    this.theGrid?.rows.forEach((row) => {
      if (row instanceof wjcGrid.GroupRow) {
        this.groupStateSnapshot.push({
          id: row.dataItem.items[0]['PREJEMNIK_ID'],
          isCollapsed: row.isCollapsed,
        });
      }
    });
  }

  private restoreGroupSnapshot() {
    this.theGrid?.rows.forEach((row) => {
      if (row instanceof wjcGrid.GroupRow) {
        row.isCollapsed =
          this.groupStateSnapshot.find((item) => item.id === row.dataItem.items[0]['PREJEMNIK_ID'])
            ?.isCollapsed ?? false;
      }
    });
  }

  setHeader() {
    if (!this.gridState.theGrid) return;
    // How many header rows?
    const headerRows = 1;
    this.gridState.theGrid.columnHeaders.rows.length = 1;
    for (let i = 1; i <= headerRows; i++) {
      const groupRow = new wjcGrid.GroupRow();
      groupRow.allowMerging = true;
      this.gridState.theGrid.columnHeaders.rows.push(groupRow);
    }
    if (this.theGrid) {
      this.theGrid.columnHeaders.rows[0].height = 30;
      this.theGrid.columnHeaders.rows[1].height = 45;
      this.theGrid.columnHeaders.rows[1].multiLine = true;
      this.theGrid.columnHeaders.rows[1].wordWrap = true;
    }
    const panel = this.gridState.theGrid.columnHeaders;
    for (let colIndex = 0; colIndex < panel.columns.length; colIndex++) {
      const column: wjcGrid.Column = panel.columns[colIndex];
      column.allowMerging = true;
      const binding = column.binding;
      switch (binding) {
        case 'EKJS_SKUPAJ':
        case 'EKSRP_SKUPAJ':
        case 'EKJS_EU':
        case 'EKJS_SLO':
        case 'EKSRP_EU':
        case 'EKSRP_SLO':
        case 'ZNESEK_SKUPAJ':
          panel.setCellData(
            0,
            colIndex,
            this.jezik === Language.EN ? 'Amount in EUR' : 'Zneski v EUR',
          );
          break;
        default:
          panel.setCellData(
            0,
            colIndex,
            this.uvozLog != null
              ? 'Zadnjič uvoženo ob ' +
                  this.uvozLog.datumUvoza?.toLocaleDateString('sl-SI') +
                  ' ' +
                  this.uvozLog.datumUvoza?.toLocaleTimeString('sl-SI') +
                  ' za sklad ' +
                  this.uvozLog.vrstaUvoza +
                  ' in leto ' +
                  this.uvozLog.leto +
                  ' (' +
                  this.uvozLog.stVrstic?.toLocaleString('sl-SI') +
                  ' vrstic)'
              : panel.getCellData(0, colIndex, true),
          );
          break;
      }
      this.gridState.theGrid.mergeManager = new VpoglednikMergeManager(headerRows);
    }
  }

  private getGridMessage(stZapisov: number) {
    if (!this.reportGrid) {
      return '';
    }
    if (!this.gridState.toggleShowSteviloZapisov) {
      this.reportGrid.setInfo();
      return '';
    }
    if (stZapisov === 0) {
      this.reportGrid.setWarning();
      return this.jezik === Language.EN
        ? 'No records exist for the selected criteria.'
        : 'Za izbrane kriterije ne obstaja noben zapis.';
    } else {
      this.reportGrid.setInfo();
      if (stZapisov === 1) {
        return this.jezik === Language.EN
          ? 'Displayed is ' + stZapisov.toLocaleString('en-US') + ' record'
          : 'Prikazan je ' + stZapisov.toLocaleString('sl-SI') + ' zapis';
      } else if (stZapisov === 2) {
        return this.jezik === Language.EN
          ? 'Displayed are ' + stZapisov.toLocaleString('en-US') + ' records'
          : 'Prikazana sta ' + stZapisov.toLocaleString('sl-SI') + ' zapisa';
      } else if (stZapisov === 3 || stZapisov === 4) {
        return this.jezik === Language.EN
          ? 'Displayed are ' + stZapisov.toLocaleString('en-US') + ' records'
          : 'Prikazani so ' + stZapisov.toLocaleString('sl-SI') + ' zapisi';
      } else {
        return this.jezik === Language.EN
          ? 'Displayed are ' + stZapisov.toLocaleString('en-US') + ' records'
          : 'Prikazanih je ' + stZapisov.toLocaleString('sl-SI') + ' zapisov';
      }
    }
  }

  protected readonly IxNgHtmlStaticUtils = IxNgHtmlStaticUtils;

  onPageChanged() {
    if (this.gridState.resultSetCount > 0 && this.reportGrid) {
      this.reportGrid.setInfo();
    }
    this.collapseGroups();
  }
}

export class VpoglednikMergeManager extends wjcGrid.MergeManager {
  _unmergedColumn: Set<string> = new Set<string>();
  private headerRows = 1;

  constructor(headerRows: number) {
    super();
    this.headerRows = headerRows;
  }

  override getMergedRange(panel: wjcGrid.GridPanel, r: number, col: number): wjcGrid.CellRange {
    const row: wjcGrid.Row = panel.rows[r];
    if (row instanceof wjcGridDetail.DetailRow) {
      if (col < 3) {
        return new wjcGrid.CellRange(r, 0, r, 2);
      }
      return new wjcGrid.CellRange(r, 3, r, panel.columns.length - 1);
    }
    const rg = new wjcGrid.CellRange(r, col);
    if (!row) {
      return rg;
    }
    if (panel.cellType === wjcGrid.CellType.ColumnHeader) {
      const column: wjcGrid.Column = panel.columns[col];
      const binding = column.binding;
      if (typeof r === 'number') {
        if (r < this.headerRows) {
          row.align = 'center';
          // expand left/right
          for (let i = rg.col; i < panel.columns.length - 1; i++) {
            if (panel.getCellData(rg.row, i, true) !== panel.getCellData(rg.row, i + 1, true)) {
              break;
            }
            rg.col2 = i + 1;
          }
          for (let i = rg.col; i > 0; i--) {
            if (panel.getCellData(rg.row, i, true) !== panel.getCellData(rg.row, i - 1, true)) {
              break;
            }
            rg.col = i - 1;
          }
        } else if (r === this.headerRows) {
          if (this._unmergedColumn.has(binding as string)) {
            rg.row = rg.row - 1;
          }
        }
      }
    }
    return rg;
  }
}
